




















import { Component,  Vue, Prop } from 'vue-property-decorator';
import { lines } from '@/api/api';
import { Notify } from 'vant';
import loading from '@/components/loading/loading.vue';

@Component({
    name: 'qroute',
    components: {
        loading
    }
})

export default class Qroute extends Vue {
    private value: string = '';
    private loading: boolean = true;
    private lines: any[] = [];
    
    // mounted
    private mounted() {
        const areaCode: any = localStorage.getItem('areaCode');
        lines(areaCode).then((res: any) => {
            // console.log(res);
            this.loading = false;
            this.lines = res.data;
        });
    }

    // methods
    // 查询
    private search(): void {
        const value: string = this.value;
        if (!value) {
            Notify('请输入线路名');
            return;
        }
        this.query(value, '1');
    }
    private query(lineName: string, isLike: string): void {
        this.$router.push({
            path: '/qrouteResult',
            query: {
                lineName,
                isLike
            }
        });
    }
}
